"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: common/ratelimit.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fcommon%2Fratelimit.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.rateLimitResponseCodeToJSON = exports.rateLimitResponseCodeFromJSON = exports.rateLimitUnitToJSON = exports.rateLimitUnitFromJSON = exports.RateLimitResponseDescriptorStatus = exports.RateLimitResponse = exports.RateLimit = exports.RateLimitDescriptorEntry = exports.RateLimitDescriptor = exports.RateLimitRequest = exports.RateLimitResponseCode = exports.RateLimitUnit = void 0;
const protobufPackage = 'pb.lyft.ratelimit';
var RateLimitUnit;
(function (RateLimitUnit) {
    RateLimitUnit["UNKNOWN"] = "UNKNOWN";
    RateLimitUnit["SECOND"] = "SECOND";
    RateLimitUnit["MINUTE"] = "MINUTE";
    RateLimitUnit["HOUR"] = "HOUR";
    RateLimitUnit["DAY"] = "DAY";
    RateLimitUnit["UNRECOGNIZED"] = "UNRECOGNIZED";
})(RateLimitUnit || (exports.RateLimitUnit = RateLimitUnit = {}));
var RateLimitResponseCode;
(function (RateLimitResponseCode) {
    RateLimitResponseCode["UNKNOWN"] = "UNKNOWN";
    RateLimitResponseCode["OK"] = "OK";
    RateLimitResponseCode["OVER_LIMIT"] = "OVER_LIMIT";
    RateLimitResponseCode["UNRECOGNIZED"] = "UNRECOGNIZED";
})(RateLimitResponseCode || (exports.RateLimitResponseCode = RateLimitResponseCode = {}));
function createBaseRateLimitRequest() {
    return { domain: '', descriptors: [], hitsAddend: 0 };
}
exports.RateLimitRequest = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.domain)) {
            message.domain = globalThis.String(object.domain);
        }
        if (globalThis.Array.isArray(object?.descriptors)) {
            message.descriptors = object.descriptors.map((e) => exports.RateLimitDescriptor.fromJSON(e));
        }
        if (isSet(object.hitsAddend)) {
            message.hitsAddend = globalThis.Number(object.hitsAddend);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.domain !== undefined && message.domain !== '') {
            obj.domain = message.domain;
        }
        if (message.descriptors?.length) {
            obj.descriptors = message.descriptors.map((e) => exports.RateLimitDescriptor.toJSON(e));
        }
        if (message.hitsAddend !== undefined && message.hitsAddend !== 0) {
            obj.hitsAddend = Math.round(message.hitsAddend);
        }
        return obj;
    },
    create(base) {
        return exports.RateLimitRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRateLimitRequest();
        message.domain = object.domain ?? '';
        message.descriptors = object.descriptors?.map((e) => exports.RateLimitDescriptor.fromPartial(e)) || [];
        message.hitsAddend = object.hitsAddend ?? 0;
        return message;
    },
};
function createBaseRateLimitDescriptor() {
    return { entries: [] };
}
exports.RateLimitDescriptor = {
    fromJSON(object) {
        const message = {};
        if (globalThis.Array.isArray(object?.entries)) {
            message.entries = object.entries.map((e) => exports.RateLimitDescriptorEntry.fromJSON(e));
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.entries?.length) {
            obj.entries = message.entries.map((e) => exports.RateLimitDescriptorEntry.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.RateLimitDescriptor.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRateLimitDescriptor();
        message.entries = object.entries?.map((e) => exports.RateLimitDescriptorEntry.fromPartial(e)) || [];
        return message;
    },
};
function createBaseRateLimitDescriptorEntry() {
    return { key: '', value: '' };
}
exports.RateLimitDescriptorEntry = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.key)) {
            message.key = globalThis.String(object.key);
        }
        if (isSet(object.value)) {
            message.value = globalThis.String(object.value);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.key !== undefined && message.key !== '') {
            obj.key = message.key;
        }
        if (message.value !== undefined && message.value !== '') {
            obj.value = message.value;
        }
        return obj;
    },
    create(base) {
        return exports.RateLimitDescriptorEntry.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRateLimitDescriptorEntry();
        message.key = object.key ?? '';
        message.value = object.value ?? '';
        return message;
    },
};
function createBaseRateLimit() {
    return { requestsPerUnit: 0, unit: RateLimitUnit.UNKNOWN };
}
exports.RateLimit = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.requestsPerUnit)) {
            message.requestsPerUnit = globalThis.Number(object.requestsPerUnit);
        }
        if (isSet(object.unit)) {
            message.unit = rateLimitUnitFromJSON(object.unit);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.requestsPerUnit !== undefined && message.requestsPerUnit !== 0) {
            obj.requestsPerUnit = Math.round(message.requestsPerUnit);
        }
        if (message.unit !== undefined && message.unit !== RateLimitUnit.UNKNOWN) {
            obj.unit = rateLimitUnitToJSON(message.unit);
        }
        return obj;
    },
    create(base) {
        return exports.RateLimit.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRateLimit();
        message.requestsPerUnit = object.requestsPerUnit ?? 0;
        message.unit = object.unit ?? RateLimitUnit.UNKNOWN;
        return message;
    },
};
function createBaseRateLimitResponse() {
    return { overallCode: RateLimitResponseCode.UNKNOWN, statuses: [] };
}
exports.RateLimitResponse = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.overallCode)) {
            message.overallCode = rateLimitResponseCodeFromJSON(object.overallCode);
        }
        if (globalThis.Array.isArray(object?.statuses)) {
            message.statuses = object.statuses.map((e) => exports.RateLimitResponseDescriptorStatus.fromJSON(e));
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.overallCode !== undefined && message.overallCode !== RateLimitResponseCode.UNKNOWN) {
            obj.overallCode = rateLimitResponseCodeToJSON(message.overallCode);
        }
        if (message.statuses?.length) {
            obj.statuses = message.statuses.map((e) => exports.RateLimitResponseDescriptorStatus.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.RateLimitResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRateLimitResponse();
        message.overallCode = object.overallCode ?? RateLimitResponseCode.UNKNOWN;
        message.statuses =
            object.statuses?.map((e) => exports.RateLimitResponseDescriptorStatus.fromPartial(e)) || [];
        return message;
    },
};
function createBaseRateLimitResponseDescriptorStatus() {
    return { code: RateLimitResponseCode.UNKNOWN, currentLimit: undefined, limitRemaining: 0 };
}
exports.RateLimitResponseDescriptorStatus = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.code)) {
            message.code = rateLimitResponseCodeFromJSON(object.code);
        }
        if (isSet(object.currentLimit)) {
            message.currentLimit = exports.RateLimit.fromJSON(object.currentLimit);
        }
        if (isSet(object.limitRemaining)) {
            message.limitRemaining = globalThis.Number(object.limitRemaining);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.code !== undefined && message.code !== RateLimitResponseCode.UNKNOWN) {
            obj.code = rateLimitResponseCodeToJSON(message.code);
        }
        if (message.currentLimit !== undefined) {
            obj.currentLimit = exports.RateLimit.toJSON(message.currentLimit);
        }
        if (message.limitRemaining !== undefined && message.limitRemaining !== 0) {
            obj.limitRemaining = Math.round(message.limitRemaining);
        }
        return obj;
    },
    create(base) {
        return exports.RateLimitResponseDescriptorStatus.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRateLimitResponseDescriptorStatus();
        message.code = object.code ?? RateLimitResponseCode.UNKNOWN;
        message.currentLimit = (object.currentLimit !== undefined && object.currentLimit !== null)
            ? exports.RateLimit.fromPartial(object.currentLimit)
            : undefined;
        message.limitRemaining = object.limitRemaining ?? 0;
        return message;
    },
};
function rateLimitUnitFromJSON(object) {
    switch (object) {
        case 0:
        case 'UNKNOWN':
            return RateLimitUnit.UNKNOWN;
        case 1:
        case 'SECOND':
            return RateLimitUnit.SECOND;
        case 2:
        case 'MINUTE':
            return RateLimitUnit.MINUTE;
        case 3:
        case 'HOUR':
            return RateLimitUnit.HOUR;
        case 4:
        case 'DAY':
            return RateLimitUnit.DAY;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return RateLimitUnit.UNRECOGNIZED;
    }
}
exports.rateLimitUnitFromJSON = rateLimitUnitFromJSON;
function rateLimitUnitToJSON(object) {
    switch (object) {
        case RateLimitUnit.UNKNOWN:
            return 'UNKNOWN';
        case RateLimitUnit.SECOND:
            return 'SECOND';
        case RateLimitUnit.MINUTE:
            return 'MINUTE';
        case RateLimitUnit.HOUR:
            return 'HOUR';
        case RateLimitUnit.DAY:
            return 'DAY';
        case RateLimitUnit.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.rateLimitUnitToJSON = rateLimitUnitToJSON;
function rateLimitResponseCodeFromJSON(object) {
    switch (object) {
        case 0:
        case 'UNKNOWN':
            return RateLimitResponseCode.UNKNOWN;
        case 1:
        case 'OK':
            return RateLimitResponseCode.OK;
        case 2:
        case 'OVER_LIMIT':
            return RateLimitResponseCode.OVER_LIMIT;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return RateLimitResponseCode.UNRECOGNIZED;
    }
}
exports.rateLimitResponseCodeFromJSON = rateLimitResponseCodeFromJSON;
function rateLimitResponseCodeToJSON(object) {
    switch (object) {
        case RateLimitResponseCode.UNKNOWN:
            return 'UNKNOWN';
        case RateLimitResponseCode.OK:
            return 'OK';
        case RateLimitResponseCode.OVER_LIMIT:
            return 'OVER_LIMIT';
        case RateLimitResponseCode.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.rateLimitResponseCodeToJSON = rateLimitResponseCodeToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=ratelimit.js.map